import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface NotificationPayload {
  title: string;
  message: string;
  description: string | null;
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private notificationSubject = new BehaviorSubject<NotificationPayload | null>(null);
  notifications$ = this.notificationSubject.asObservable();

  openPopup(title: string, message: string, description: string | null = null): void {
    this.notificationSubject.next({ title, message, description });
  }

  clear(): void {
    this.notificationSubject.next(null);
  }
}
